module.exports = __webpack_public_path__ + "img/WeightVsOwnsCluster.09eb1d71.png";